import {createContext, useContext, useEffect, useState} from "react";
import { checkAuth } from "../utilities/authUtils";
import { logout as logoutAPI, login as loginAPI } from "../services/ledgerService.js";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const verifyAuth = async () => {
            try {
                const isAuth = await checkAuth();
                setIsAuthenticated(isAuth);
            } catch (e) {
                setIsAuthenticated(false);
            }
        };
        verifyAuth();
    }, []);

    const loginWithGoogle = () => {
        window.location.href = "/auth/login"
    };

    const logout = async () => {
        try {
            await logoutAPI();
            setIsAuthenticated(false);
        } catch (e) {
            throw e;
        }
    }

    const login = async ({ email, password }) => {
        try {
            const user = await loginAPI({ email, password });
            setIsAuthenticated(true);
            setUser(user);
        } catch (e) {
            throw e;
        }
    }

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            user,
            loginWithGoogle,
            logout,
            login,
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
